import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import reportsListBg from '../../assets/images/reports_list_bg.png';

const StyledContainer = styled.div`
	position: relative;
	z-index: 10;
	display: grid;
	grid-template-columns: 540px 1fr;
	gap: 20px;
	padding: 20px 40px 40px;
	width: 100%;
	height: 958px;
`;

const StyledLeftContainer = styled.div`
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	background-image: url(${reportsListBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledLeftHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledListTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		opacity: 0.75;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-size: 16px;
		color: rgba(255, 255, 255, 0.75);
	}
`;

const StyledReportList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	overflow-y: scroll;
	margin-top: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledEmptyList = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;

	${Text} {
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledCount = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	height: 20px;
	padding: 0 5px;
	background-color: #1782ff;
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledCreateButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		width: 20px;
		height: 20px;
		filter: invert(1);
	}
`;

export {
	StyledContainer,
	StyledCount,
	StyledCreateButtonContent,
	StyledEmptyList,
	StyledLeftContainer,
	StyledLeftHeadContainer,
	StyledListTitle,
	StyledReportList,
};
